import { render, staticRenderFns } from "./FormPhoto.vue?vue&type=template&id=cc0f1e9a&scoped=true"
import script from "./FormPhoto.vue?vue&type=script&lang=ts"
export * from "./FormPhoto.vue?vue&type=script&lang=ts"
import style0 from "./FormPhoto.vue?vue&type=style&index=0&id=cc0f1e9a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0f1e9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc0f1e9a')) {
      api.createRecord('cc0f1e9a', component.options)
    } else {
      api.reload('cc0f1e9a', component.options)
    }
    module.hot.accept("./FormPhoto.vue?vue&type=template&id=cc0f1e9a&scoped=true", function () {
      api.rerender('cc0f1e9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/FormPhoto.vue"
export default component.exports